export default {
  data: () => ({
    windowWidth: window.innerWidth,
  }),
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },
  computed: {
    xs() {
      return this.windowWidth < 600;
    },
    sm() {
      return this.windowWidth > 600 && this.windowWidth < 900;
    },
  },
};
